<template>
    <div
        class="video-container"
        :style="customStyle"
        v-if="videoId !== '' && isIframe"
    >
        <vue-plyr ref="videoPlayer" v-if="showPlayer">
            <iframe
                :src="youtubeEmbedUrl"
                allowfullscreen
                allowtransparency
                allow="autoplay"
            ></iframe>
        </vue-plyr>
    </div>
    <div v-else>
        <vue-plyr ref="videoEmbedPlayer">
            <div data-plyr-provider="youtube" :data-plyr-embed-id="youtubeEmbedUrl"></div>
        </vue-plyr>
    </div>
</template>

<script>
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

const getYouTubeId = (url) => {
    const arr = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return undefined !== arr[2] ? arr[2].split(/[^\w-]/i)[0] : arr[0];
};

export default {
    components: { VuePlyr },

    props: {
        videoId: String,
        showPlayer: Boolean,
        isIframe: Boolean,
    },

    data() {
        return {
            width: '0',
            height: '0',
        };
    },

    computed: {
        youtubeVideoId: function () {
            return getYouTubeId(this.videoId);
        },
        youtubeEmbedUrl: function () {
            return 'https://www.youtube.com/embed/' + this.youtubeVideoId + '?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1';
        },
        customStyle: function () {
            return {
                backgroundImage: "url('https://img.youtube.com/vi/" + this.youtubeVideoId + "/maxresdefault.jpg')",
                width: this.width,
                height: this.height,
            };
        },
    },

    mounted: function () {
        let availableWidth = $('.main-container').innerWidth();
        let aspectRatio = (537 / 1362);

        this.height = aspectRatio * availableWidth + 'px';
        this.width = availableWidth + 'px';
    },

    beforeDestroy() {
        if (this.$refs.videoEmbedPlayer) {
            this.$refs.videoEmbedPlayer.plyr.pause();
        }
    },
};
</script>
